import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMicrosoftexcelComponent } from './simple-icons-microsoftexcel.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMicrosoftexcelComponent ],
    exports:      [ SimpleIconsMicrosoftexcelComponent ],
    bootstrap:    []
})
export class SimpleIconsMicrosoftexcelModule {}
